import React from "react";
import {detectFileType} from "@/utils/fileTypeDetection";
import {getFileTypeIcon} from "@/utils/fileHelpers";
import PdfThumbnail from "../../common/PdfThumbnail";
import DocxThumbnail from "../../common/DocxThumbnail";
import ExcelThumbnail from "../../common/ExcelThumbnail";
import Icon, {ICON_SIZES} from "../../library/Icon";

const FileThumbnail: React.FC<{
   fileType: ReturnType<typeof detectFileType>;
   dataUrl: string;
   blobUrl: string | null;
   excelData: string[][] | null;
   base64Data: string;
   /** Remote file location; takes precedence over the base64-derived sources. */
   url?: string;
   fileName: string;
   mimeType: string;
}> = ({fileType, dataUrl, blobUrl, excelData, base64Data, url, fileName, mimeType}) => {
   if (fileType.isImage) {
      return <img src={url ?? dataUrl} alt={fileName} className="w-full h-full object-cover" />;
   }
   if (fileType.isPdf) {
      return <PdfThumbnail file={url ?? `data:application/pdf;base64,${base64Data}`} width={200} />;
   }
   if (fileType.isDocx && blobUrl) {
      return <DocxThumbnail url={blobUrl} />;
   }
   if (fileType.isExcel && excelData) {
      return <ExcelThumbnail data={excelData.slice(0, 8)} />;
   }
   return <Icon icon={getFileTypeIcon(fileName, mimeType)} size={ICON_SIZES.XXL} className="text-400" />;
};

export default FileThumbnail;
